export default __webpack_public_path__ + "static/media/Enlightened.9cd7aba7.jpg";